module.exports = __webpack_public_path__ + "img/img_step02@2x.e1b4c601.png";